const tabs = {
  main: [
    {
      name: 'service',
      label: 'tab.serviceRequest',
      href: '/service-request/vehicle-identification/catalog-selection',
      dataJs: 'service'
    },
    {
      name: 'conversation',
      label: 'tab.conversation',
      href: '/conversation',
      dataJs: 'contact'
    }
  ],
  reject: [
    {
      name: 'reject',
      label: 'tab.reject',
      hide: true
    }
  ],
  rating: [
    {
      name: 'rating',
      label: 'tab.rating',
      href: '/rating',
      hide: true
    }
  ],
  vehicleIdentification: [
    {
      name: 'catalogIdentification',
      label: 'catalog.selection',
      href: '/service-request/vehicle-identification/catalog-selection',
      type: 'vehicleIdentification'
    }, {
      name: 'vinSelection',
      label: 'vin.selection',
      href: '/service-request/vehicle-identification/vin-selection',
      type: 'vehicleIdentification'
    }
  ]
};

export default tabs;
